import PIIVerifyNowBg from 'assets/ver2/images/pii-verify-bg.jpg';
import SecurityAnimationJson from 'assets/ver2/lotties/security-animation.json';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import Lottie from 'lottie-react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixin,
  paragraph500Mixin,
  paragraphMixin,
} from 'styles';

const PIIVerifyNowPopup = ({
  isOpen,
  buttonLabel1,
  onClose,
  buttonLabel2,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const renderContentTitle = () => {
    return (
      <Text
        dangerouslySetInnerHTML={{
          __html: t('form_pii_verify_now_title'),
        }}
      />
    );
  };
  const renderContentMessage = () => {
    return (
      <SubText
        dangerouslySetInnerHTML={{
          __html: t('form_pii_verify_now_desc'),
        }}
      />
    );
  };
  const renderBodyContent = () => (
    <>
      <ImageWrap>
        <Lottie
          animationData={SecurityAnimationJson}
          loop={true}
          style={{
            width: isDesktop ? '200px' : '150px',
            height: isDesktop ? '200px' : '150px',
          }}
        />
      </ImageWrap>
      <SizeBox height={20} />
      {renderContentTitle()}
      <SizeBox height={10} />
      {renderContentMessage()}
      <SizeBox height={isDesktop ? 20 : 0} />
    </>
  );

  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={buttonLabel1}
      onClick={onClose}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--ds-c-blue)"
      background={isDesktop ? 'var(--ds-c-white)' : 'transparent'}
    />
  );
  const renderActionButton2 = (width) => (
    <ButtonCommon
      value={buttonLabel2}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      onClick={onClick}
      isUseKeyDown
    />
  );
  const renderActionButtons = () => {
    if (isDesktop)
      return (
        <>
          {renderActionButton1('calc(50% - 4px)')}
          {renderActionButton2('calc(50% - 4px)')}
        </>
      );
    return (
      <>
        {renderActionButton2('100%')}
        <SizeBox height={16} />
        {renderActionButton1('100%')}
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal &&
          `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .pii-verify-now-modal {
              z-index: ${zIndexModal || '1101'};
            }
          }
        `}
        {isBackdropOverlap
          ? `
          .pii-verify-now-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || '1100'};
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .pii-verify-now-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="pii-verify-now-modal"
        backdropClassName="pii-verify-now-modal-backdrop"
        centered
      >
        <ModalBody>{renderBodyContent()}</ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  &.modal {
    padding-left: 0 !important;
    padding-right: 0px !important;
  }

  & .modal-content {
    background-image: url(${PIIVerifyNowBg}) !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: 540px 100% !important;
  }

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        border-radius: 0px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 16px 16px 0 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 40px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 540px;
        height: fit-content;
        margin-inline: auto;
        border: none;
        border-radius: 8px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 0px;
  padding-top: 20px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-top: unset;
  }
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Text = styled.p`
  ${paragraphMixin};
  font-family: var(--ff-quaternary);
  font-weight: 400;
  text-align: center;
  font-size: 30px;
  line-height: 36px;
`;

const SubText = styled.p`
  ${paragraphMixin};
  ${paragraph500Mixin};
  text-align: center;
  white-space: break-spaces;
  color: var(--ds-c-grey-dark);
  margin: 0;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  ${displayFlexColCenterCenterMixin};
  margin-inline: -16px;
  padding-inline: 16px;
  padding-block: 16px 20px;
  border: none;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    padding-block: unset;
    padding-inline: unset;
    margin-inline: unset;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export default PIIVerifyNowPopup;
